import type { FaireProductEntity } from "../../entity_types/product";

export const p_8mzk5vf287: FaireProductEntity = {
  token: "p_8mzk5vf287",
  type: "product",
  name: "Women's Cozy Faux Mink Cardigan Sweater_CWMM8454",
  brandToken: "b_3eopd3scey",
  brandName: "ACCITY",
  imageUrl:
    "https://cdn.faire.com/fastly/ced5452f9af18044c97e201a38731786f8595c6c11a1cb89c554a4fef840202b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a6b9d579221b768b3e815d4ee3fe8f496abd3f27532b13c0265367d8405057aa.jpeg",
    "https://cdn.faire.com/fastly/5f86cd4b2ddd8d7cdfe6e641c7551a7876086788dfe1fad73e4d16f2165313de.jpeg",
    "https://cdn.faire.com/fastly/1fba514223a99998e4e832c7d35a6331d8fc31595e44a7aa230596caba2a20dc.jpeg",
    "https://cdn.faire.com/fastly/b135e4329fdf0f9b59128b54ebcb3c1d882cc737f693b514655a038f5ef33b31.jpeg",
    "https://cdn.faire.com/fastly/4ccce389ac6638a60b2d1eb77dcd7cf12ab3bcb8b05e1c2a65746c9ccd5f0431.jpeg",
    "https://cdn.faire.com/fastly/27fec2520cfa1a1d56f7e60a6dabf17de08c5855fc260c6620cbb54a60a7aacf.jpeg",
    "https://cdn.faire.com/fastly/5240e53ec9b9b50392f00043fa5e8d8abedb12de94b46aca9a4cfb7275f18292.jpeg",
    "https://cdn.faire.com/fastly/1e2b07b007f4dfd3b19577cc097096dcbb9457e9bdec2254541d72ff6683e61c.jpeg",
    "https://cdn.faire.com/fastly/7aff401fc43b2d31f83c9f7ef55ddbd6769839fa2c598a371f23fdeade734b03.jpeg",
    "https://cdn.faire.com/fastly/ed58ffc796c423db8842e9f3edd74c581015af999bc81d84e4842b0a8c0de85a.jpeg",
    "https://cdn.faire.com/fastly/bfc48549ae8732bcde324ea0b96e3b70148ad6e7c13f4aee39d5d6fd5a4b3af7.jpeg",
    "https://cdn.faire.com/fastly/85e4d1c27bc0c75f83432846739f22b6a8f22a2e9cbb9ac9e693ddd1dac88ec0.jpeg",
    "https://cdn.faire.com/fastly/4a37d376118cbb9d7b4d951b291a16a28526bc895d78a4aba4cdafe4365a7997.jpeg",
  ],
  priceDollars: 37.76,
  description:
    '▸Material: Faux Mink Fleece (Soft & Warm)\n▸Weight: 25.4 oz (720g)\n▸Style: Korean-Inspired Open Front\n▸US Size\tBust (Inches)\tLength\nXS\t32-34"\t22"\nS\t34-36"\t22"\nM\t36-38"\t22.5"\nL\t38-40"\t22.5"\nXL\t40-42"\t23"\nXXL\t42-44"\t23"\nXXXL\t44-46"\t23.5"\n\n"Types Of Products That Will Be On The Shelves During This Period:\nCardigan, Knit cardigan, Chunky cardigan, Long cardigan, Cropped cardigan, Oversized cardigan, Button up cardigan, Open front cardigan, Cable knit cardigan, Ribbed cardigan, Lightweight cardigan, Soft knit cardigan, Cozy cardigan, Fall cardigan, Winter cardigan, Wool blend cardigan, Fuzzy cardigan, Slouchy cardigan, Hooded cardigan, V-neck cardigan, Boho cardigan, Vintage cardigan, Striped cardigan, Color block cardigan, Floral knit cardigan, Minimalist cardigan, Casual cardigan, Knit sweater cardigan, Women’s cardigan, Men’s cardigan."',
  tags: [],
  msrpDollars: 75.52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:57.328Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
